import { createSlice } from "@reduxjs/toolkit";

const initialInterviewGuideState = {
  page: null,
  limit: null,
  totalPages: null,
  listLoading: false,
  totalResults: null,
  actionLoading: false,
  interviewGuides: [],
  selectedInterviewGuide: null,
};

export const initialInterviewGuideSlice = createSlice({
  name: "initialInterviewGuideState",
  initialState: initialInterviewGuideState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload === "action") {
        state.actionLoading = true;
      } else {
        state.listLoading = true;
      }
    },
    stopCall: (state, action) => {
      if (action.payload === "action") {
        state.actionLoading = false;
      } else {
        state.listLoading = false;
      }
    },
    saveInterviewguides: (state, action) => {
      const { page, limit, totalPages, totalResults, interviewGuides } = action?.payload;
      state.interviewGuides = interviewGuides;
      state.page = page;
      state.limit = limit;
      state.totalPages = totalPages;
      state.totalResults = totalResults;
      state.listLoading = false;
    },
    setInterviewguides: (state, action) => {
      state.selectedInterviewGuide = action?.payload?.data?.data;
    },
  },
});
